import React from 'react';
import { useNavigate } from 'react-router-dom';
import CrmLayout from '@/modules/crm/components/CrmLayout';
import ContactForm from '@/modules/crm/components/ContactForm';
import { useCreateContact } from '@/hooks/queries';
import { useToast } from '@/hooks/useToast';

export default function CrmNewContactPage() {
  const navigate = useNavigate();
  const { toasts, showToast, hideToast } = useToast();
  const createMutation = useCreateContact();

  const handleSubmit = (formData) => {
    createMutation.mutate(formData, {
      onSuccess: (newContact) => {
        showToast('Contact created', 'success');
        navigate(`/crm/contacts/${newContact.id}`);
      },
      onError: (error) => {
        showToast(error.message || 'Failed to create contact', 'error');
      },
    });
  };

  return (
    <CrmLayout toasts={toasts} onCloseToast={hideToast}>
      {/* Back Button */}
      <button
        onClick={() => navigate('/crm/contacts')}
        className="inline-flex items-center text-zapt-purple hover:text-zapt-purple/80 font-medium mb-6"
      >
        <svg className="w-4 h-4 mr-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
        </svg>
        Back to Contacts
      </button>

      <div className="max-w-2xl">
        <div className="bg-white rounded-lg border border-gray-200 p-6">
          <h1 className="text-2xl font-bold text-gray-900 mb-6">Add New Contact</h1>
          
          <ContactForm
            onSubmit={handleSubmit}
            onCancel={() => navigate('/crm/contacts')}
            isSubmitting={createMutation.isPending}
          />
        </div>
      </div>
    </CrmLayout>
  );
}
